import type { ReactNode } from 'react';

/**
 * 主視覺橫幅 — 業主 2026-08-18 設計稿：酒店與遊艇實景照，小獅船長站在中間，
 * 下緣以白色波浪切出，接到內容區。
 *
 * 照片取自業主 2026-08-19 交付的《票務系統UI素材》首頁背板（1_01.png，1080×1920
 * 去字底圖），裁到白色波浪開始之前——背板自己帶了波浪，這裡也會畫一層，不裁會疊。
 *
 * 底下仍留品牌漸層：照片載不出來時（檔案缺漏、快取失效）露出來的是一片品牌色，
 * 而不是空白或破圖。
 */
const HERO_PHOTO = '/brand/hero-resort.jpg';

interface HeroBannerProps {
  /** 疊在主視覺上的內容（通常是小獅船長）。 */
  children?: ReactNode;
  /** 橫幅高度 px；設計稿首頁約 700、內頁約 420。 */
  height?: number;
  /**
   * 內容擺放位置。`center` 貼齊下緣置中（首頁）；`left` 靠左並跨出橫幅下緣，
   * 讓小獅船長站在波浪上（設計稿「專屬行程」頁）。
   */
  align?: 'center' | 'left';
}

export function HeroBanner({
  children,
  height = 420,
  align = 'center',
}: HeroBannerProps): JSX.Element {
  const left = align === 'left';
  return (
    <div className={`k-hero${left ? ' k-hero--overflow' : ''}`} style={{ height }}>
      <div
        className="k-hero__photo"
        /* 照片不存在時 background-image 靜默失敗，露出底下的品牌漸層，不會破圖 */
        style={{ backgroundImage: `url(${HERO_PHOTO})` }}
        aria-hidden="true"
      />
      <div className={`k-hero__content${left ? ' k-hero__content--left' : ''}`}>{children}</div>
      {/* 下緣白色波浪：與頁尾金色波浪同一套語彙 */}
      <svg
        className="k-hero__wave"
        viewBox="0 0 1080 80"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path
          d="M0,80 L0,44 C180,4 360,4 540,30 C720,56 900,72 1080,36 L1080,80 Z"
          fill="var(--c-bg)"
        />
      </svg>
    </div>
  );
}
